import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputError from '../../../errors/InputError';
import './TextInput.css';

export default class TextInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: (this.props.existingContent !== undefined && this.props.existingContent !== null) ? this.props.existingContent : ""
    };
    this.newValue = null;
    this.newSelectionStart = null;
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if ('existingContent' in newProps && newProps.existingContent !== undefined && newProps.existingContent !== this.state.value) {
      this.setState({ value: newProps.existingContent });
    }

    if (this.props.selectedOption !== null) {
      const selectedOption = newProps.selectedOption;

      if (selectedOption !== this.props.selectedOption) {
        if (selectedOption !== '')
          this.setState({ value: selectedOption })
      }
    }
  }

  componentDidUpdate(prevProps) {
    let input = document.getElementById(this.props.id);
    let needToValidate = false;

    if (this.newValue !== null) {
      input.value = this.newValue;
      this.newValue = null;
      needToValidate = true;
    }
    if (this.newSelectionStart !== null) {
      input.selectionStart = this.newSelectionStart;
      input.selectionEnd = this.newSelectionStart;
      this.newSelectionStart = null;
      needToValidate = true;
    }
    if (this.props.validateOnChange && needToValidate) {
      this.validate(input, false);
    }
  }

  componentDidMount() {
    let target = document.getElementById(this.props.id);
    if (target && target.value) {   // Is a string with length > 0
      this.validate(target, true);
    }
  }

  focusAtSetCaret(caretPos) {
    let elem = this[`${this.props.id}__text-input`];
    if (elem != null) {
      elem.focus();
      if (elem.createTextRange) {
        let range = elem.createTextRange();
        range.move('character', caretPos);
        range.select();
      }
      else if (elem.setSelectionRange) {
        elem.setSelectionRange(caretPos, caretPos);
      }
    }
  }

  hasFocus() {
    return this[`${this.props.id}__text-input`] === document.activeElement;
  }

  selectionStart() {
    return this[`${this.props.id}__text-input`].selectionStart;
  }

  getValue = () => {
    let value = this.state.value;

    if (this.props.trim) {
      value = value.trim();
      this.setState({ value });
    }

    if (this.props.required && value === "") {
      throw new InputError(this.props.label + " is Required", value);
    }

    // only validate the regex if the field is populated
    if (this.props.patternMatch && value !== "") {
      if (!value.match(this.props.patternMatch)) {
        let patternError = (this.props.patternMatchError) ?
          this.props.patternMatchError :
          this.props.label + " is Invalid";

        throw new InputError(patternError, value);
      }
    }

    return value;
  }

  validate = (target, inv) => {
    let newErrorMessage = null;
    if (this.props.patternMatch) {
      if (target.value && !target.value.match(this.props.patternMatch)) {
        newErrorMessage = (this.props.patternMatchError) ?
          this.props.patternMatchError :
          this.props.label + " is not the correct format.";
      }
    }
    if (this.props.required) {
      if (!target.value) {
        newErrorMessage = (this.props.requiredError) ?
          this.props.requiredError :
          this.props.label + " is a required field.";
      }
    }
    if (newErrorMessage && inv) {
      this.setState({ className: this.props.validationErrorClass });
    }
    if (!newErrorMessage || inv) {
      this.setState({
        validationError: newErrorMessage,
        contentWrapperClass: newErrorMessage ? this.props.validationErrorClass : ''
      });
    }
  }

  handleChange = (e) => {
    e.persist();

    let callOnChange = () => {
      if (this.props.onChange) {
        let newValues = this.props.onChange(e);
        if (typeof newValues === "object") {
          if (newValues["value"] !== undefined) {
            this.newValue = newValues.value;
          }
          if (newValues["selectionStart"] !== undefined) {
            this.newSelectionStart = newValues.selectionStart;
          }
        }
      }
      if (this.props.validateOnChange) {
        this.validate(e.target, false);
      }
    }

    this.setState((state, props) => {
      if (props.maxLength) {
        if (typeof e.target.value === 'number') {
          return {
            value: parseInt(e.target.value.toString().slice(0, props.maxLength), 10)
          }
        }
        else {
          return {
            value: e.target.value.slice(0, props.maxLength)
          }
        }
      }
      else {
        return { value: e.target.value }
      }
    }, callOnChange);
  }

  handleBlur = (e) => {
    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
    if (this.props.validateOnBlur) {
      this.validate(e.target, true);
    }
  }

  handleKeyUp = (e) => {
    if (this.props.onKeyUp) {
      this.props.onKeyUp(e);
    }
  }

  render() {

    let label = (this.props.label) ?
      <label htmlFor={this.props.id}>
        {this.props.label}
      </label> :
      null;

    let inputHelperText = this.props.helperText;
    let inputInfoText = this.props.infoText;

    let helperText = inputHelperText ?
      <span className="helper-text">
        {inputHelperText}
      </span> :
      null;

    let infoText = inputInfoText ?
      <span className="info-text">
        {inputInfoText}
      </span> :
      null;

    let errorText = this.props.errorMessage;
    if (!errorText && this.state.validationError) {
      errorText = this.state.validationError;
    }
    let errorMessage = errorText ?
      <span className="error-message">
        {errorText}
      </span> :
      null;

    let existingContent = (this.props.type !== "password" || !this.props.existingContent) ?
      this.props.existingContent :
      this.props.existingContent.replace(/.*/, '**********');

    let requiredFieldIndicator = (this.props.required) ?
      <abbr title="This field is required"></abbr> :
      null;

    let verticalSpacingClass = this.props.verticalSpacing === "compact" ? "field--compact" : "field";

    let contentWrapperClass = this.props.contentWrapperClass;
    if (this.state.contentWrapperClass) {
      contentWrapperClass += " " + this.state.contentWrapperClass;
    }

    let numberMax = this.props.numberMax;
    if ((numberMax === undefined || numberMax === null) && this.props.type === 'date') {
      numberMax = '9999-12-31';
    }

    let inputDisplay = (this.props.isEditable) ?
      <span className={contentWrapperClass}>
        {infoText}
        <div className="label-wrapper">
          {label}
          {requiredFieldIndicator}
        </div>
        <input
          autoComplete={(this.props.autoComplete) ? null : "off"}
          className={this.props.className}
          disabled={this.props.disabled}
          id={this.props.id}
          max={numberMax}
          min={this.props.numberMin}
          maxLength={this.props.maxLength}
          minLength={this.props.minLength}
          onBlur={(e) => this.handleBlur(e)}
          onChange={(e) => this.handleChange(e)}
          onKeyUp={(e) => this.handleKeyUp(e)}
          placeholder={this.props.placeholderText}
          ref={instance => { this[`${this.props.id}__text-input`] = instance; }}
          required={this.props.required}
          step={this.props.numberStep}
          type={this.props.type}
          value={this.state.value}
        />
        {helperText}
        {errorMessage}
      </span> :
      <span className={this.props.contentWrapperClass}>
        {label}
        <div className="read-only">
          {existingContent}
        </div>
      </span>;

    return (
      <div className={verticalSpacingClass}>
        {inputDisplay}
      </div>
    );
  }
}

TextInput.defaultProps = {
  autoComplete: true,
  isEditable: true,
  trim: false,
  type: "text"
};

TextInput.propTypes = {
  autoComplete: PropTypes.bool,
  className: PropTypes.string,
  contentWrapperClass: PropTypes.string,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  existingContent: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  id: PropTypes.string.isRequired,
  infoText: PropTypes.string,
  isEditable: PropTypes.bool,
  label: PropTypes.string,
  maxLength: PropTypes.string,
  minLength: PropTypes.string,
  numberMax: PropTypes.string,
  numberMin: PropTypes.string,
  numberStep: PropTypes.string,
  onChange: PropTypes.func,
  patternMatch: PropTypes.instanceOf(RegExp),
  patternMatchError: PropTypes.string,
  placeholderText: PropTypes.string,
  required: PropTypes.bool,
  requiredError: PropTypes.string,
  selectedOption: PropTypes.string,
  trim: PropTypes.bool,
  type: PropTypes.string,
  validateOnBlur: PropTypes.bool,
  validateOnChange: PropTypes.bool,
  validationErrorClass: PropTypes.string,
  verticalSpacing: PropTypes.string
}
